module.exports = __webpack_public_path__ + "img/avatar02.26132948.jpg";